
import React from 'react';
import QuestionForm from './QuestionForm';
import QuestionList from './QuestionList';
import Card from '../common/Card';

const QuestionsTab = () => {
  return (
    <div className="questions-tab">
      <Card>
        <h2 className="card-title">❓ Manage Interview Questions</h2>
        <QuestionForm />
        <QuestionList />
      </Card>
    </div>
  );
};

export default QuestionsTab;
